import { render, staticRenderFns } from "./AdminEditAssetTable.vue?vue&type=template&id=5c5050ca&scoped=true&"
import script from "./AdminEditAssetTable.vue?vue&type=script&lang=js&"
export * from "./AdminEditAssetTable.vue?vue&type=script&lang=js&"
import style0 from "./AdminEditAssetTable.vue?vue&type=style&index=0&id=5c5050ca&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5050ca",
  null
  
)

export default component.exports